import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Router, Route, Switch } from "react-router-dom";

import store from 'store';

import AuthRoute from 'routes/AuthRoute/AuthRoute';
import history from 'routes/History/history';
import indexRoutes from "routes/index.jsx";

import './App.css';

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router history={history}>
          <Switch>
            {indexRoutes.map((prop, key) => {
              return <AuthRoute
                path={prop.path}
                data={prop}
                component={prop.component}
                key={key} />;
            })}
          </Switch>
        </Router>        
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx